import { render, staticRenderFns } from "./tiedCardFormAgain.vue?vue&type=template&id=a0151fae"
import script from "./tiedCardFormAgain.vue?vue&type=script&lang=js"
export * from "./tiedCardFormAgain.vue?vue&type=script&lang=js"
import style0 from "./tiedCardFormAgain.vue?vue&type=style&index=0&id=a0151fae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports